import Carousel from "react-bootstrap/Carousel";
import BrandIcon1 from "../../../assest/brandLogo/Brand1.png";
import BrandIcon2 from "../../../assest/brandLogo/Brand2.png";
function BrandCarousel() {
  return (
    <Carousel>
      <Carousel.Item>
        <img
          className="d-block carouselImage"
          src={BrandIcon1}
          alt="First slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block carouselImage"
          src={BrandIcon2}
          alt="Second slide"
        />
      </Carousel.Item>
    </Carousel>
  );
}

export default BrandCarousel;
